module.exports = __webpack_public_path__ + "img/menu_item3.8cc46c7b.svg";